module.exports = __webpack_public_path__ + "img/banner_app.784646a5.png";